export const SMARTCAPTCHA_CLIENT_KEY =
  'ysc1_AGuK8tHgvSwkKvbkjsniqf2AbIHWrdyNradR0HEN7fc74e7b';
